import { AfterViewInit, Component, ElementRef, inject, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbCalendar, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormBuilder, FormControl, Validators } from '@angular/forms';
import { DayOfWeekCheck } from '@pos-app/data';
import { EventService } from '@pos-app/core-ui';
import { takeUntil } from 'rxjs/operators';
import { Subject, BehaviorSubject } from 'rxjs';
import { arraysContainSame, getDaysOfWeek } from '../../scheduler-helper';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-schedulerSetWorkshopDays',
    styleUrls: ['./schedulerSetWorkshopDays.component.css'],
    templateUrl: './schedulerSetWorkshopDays.component.html',
    standalone: false
})
export class SchedulerSetWorkshopDays implements OnInit, AfterViewInit {
  @ViewChild('d2', { static: true }) d2;
  unSubscribe$ = new Subject<void>();
  @Input() actionSetWorkshopDay;
  @Input() defaultBranch: string;
  @Input() currentDate: string;
  @Input() globalData;
  setWorkshopDayHourForm: UntypedFormGroup;
  setWorkshopAdhocDayForm: UntypedFormGroup;
  private _loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loading$ = this._loadingSubject.asObservable();
  get loading(): boolean {
    return this._loadingSubject.value;
  }
  set loading(v: boolean) {
    this._loadingSubject.next(v);
  }
  calendarViewStatus: boolean = false;
  fetchedMonth: Array<String> = [];
  showRecurringDay: boolean = false;
  originalWorkshopDate: Array<String> = [];
  isFormValid: boolean = false;
  daysOfWeek: Array<DayOfWeekCheck> = getDaysOfWeek();
  today = inject(NgbCalendar).getToday();
  model: NgbDateStruct;
  date: { year: number; month: number };
  showDateTimeFrame: boolean = false;
  isFromRecurring: boolean = false;
  currentMonth: number;
  timeframeEditable: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private eventService: EventService,
    private toastr: ToastrService,
    private renderer: Renderer2,
    private confirmationService: ConfirmationService
  ) {}
  ngAfterViewInit(): void {
    this.streamOpened(event);
  }
  ngOnInit(): void {
    this.setWorkshopDayHourForm = this.fb.group({
      workshopOpenDates: [[]],
      workshopClosedDates: [[]],
      recurringOpenDays: [[]],
      recurringCloseDays: [[]],
      recurringStartDate: [''],
      recurringEndDate: [''],
      timeframe: [''],
    });

    this.setWorkshopAdhocDayForm = this.fb.group({
      workshopOpenDates: [[]],
      workshopClosedDates: [[]],
      recurringOpenDays: [[]],
      recurringCloseDays: [[]],
      recurringStartDate: [''],
      recurringEndDate: [''],
    });

    this.setWorkshopAdhocDayForm.get('workshopOpenDates').valueChanges.subscribe(() => {
      const val = this.setWorkshopAdhocDayForm.getRawValue();
      if (val.recurringStartDate && (val.recurringOpenDays.length > 0 || val.recurringCloseDays.length > 0)) {
        this.isFormValid = true;
      } else {
        this.isFormValid = true;
      }
    });

    this.setWorkshopDayHourForm.get('timeframe').valueChanges.subscribe(() => {
      const val = this.setWorkshopDayHourForm.getRawValue();

      if (val.timeframe === 2) {
        this.showDateTimeFrame = true;
        this.setWorkshopDayHourForm.patchValue({
          recurringStartDate: this.currentDate,
          recurringEndDate: '01/01/2040',
        });
        this.timeframeEditable = false;
      }
      if (val.timeframe === 3) {
        this.showDateTimeFrame = true;
        this.setWorkshopDayHourForm.patchValue({
          recurringStartDate: '',
          recurringEndDate: '',
        });
        this.timeframeEditable = true;
      }
    });
  }

  submitWorkshopDayHourForm(submit) {
    this.activeModal.close();
  }

  onChange(form) {
    // reset the form value to the newly emitted form group value.
    this.setWorkshopDayHourForm = form;
  }
  streamOpened(event) {
    this.showRecurringDay = false;
    document.querySelectorAll('.ngb-dp-month').forEach((el) => {
      el.className = 'ngb-dp-month-custom';
    });
    document.querySelectorAll('.ngb-dp-weekdays').forEach((el) => {
      el.className = 'ngb-dp-week ngb-dp-weekdays ng-star-inserted ngb-dp-weekdays-custom';
    });
    document.querySelectorAll('.ngb-dp-week').forEach((el, i) => {
      if (i === 0) {
        el.className = 'ngb-dp-week ng-star-inserted ngb-dp-week-label-custom';
      } else {
        el.className = 'ngb-dp-week ng-star-inserted ngb-dp-week-custom';
      }
    });
    document.querySelectorAll('.ngb-dp-day.ng-star-inserted').forEach((el) => {
      el.className = 'ngb-dp-day ng-star-inserted ngb-dp-day-custom';
    });
    setTimeout(() => {
      let x = document.querySelectorAll('.ngb-dp-day');
      if (this.dateToString(x[0]?.getAttribute('aria-label')) && this.dateToString(x[x.length - 1]?.getAttribute('aria-label'))) {
        this.fetchMonthlyViewForOrder(
          this.dateToString(x[0]?.getAttribute('aria-label')),
          this.dateToString(x[x.length - 1]?.getAttribute('aria-label'))
        );
      }
      this.showRecurringDay = false;
    }, 101);
  }

  dateToString(date: any) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [day, month, year].join('/');
  }
  fetchMonthlyViewForOrder(startDate, endDate) {
    this.loading = true;
    if (this.fetchedMonth.filter((el) => el === startDate).length < 1 || this.isFromRecurring === true) {
      this.isFromRecurring = false;
      this.eventService
        .fetchWorkshopOpenDays({
          startDate: startDate,
          endDate: endDate,
          branch: this.defaultBranch,
        })
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((res: any) => {
          this.loading = false;

          if (res) {
            this.setWorkshopDayHourForm.patchValue({
              workshopOpenDates: res?.workshopOpenDates?.concat(
                this.setWorkshopDayHourForm?.value?.workshopOpenDates?.filter((item) => res?.workshopOpenDates.indexOf(item) < 0)
              ),
            });
            this.originalWorkshopDate = res?.workshopOpenDates?.concat(
              this.originalWorkshopDate?.filter((item) => res?.originalWorkshopDate?.indexOf(item) < 0)
            );
            setTimeout(() => {
              let buttons = document.querySelectorAll('.ngb-dp-day:not(.disabled):not(.weekend)');
              buttons.forEach((btn) =>
                this.renderer.listen(btn, 'click', () => {
                  setTimeout(() => {
                    //debugger
                    this.displayMonth(this.setWorkshopDayHourForm?.value.workshopOpenDates);
                  });
                })
              );
              this.displayMonth(this.setWorkshopDayHourForm?.value.workshopOpenDates);
            });
          }
        });
      this.fetchedMonth.push(startDate);
    } else {
      this.displayMonth(this.setWorkshopDayHourForm?.value.workshopOpenDates);
    }
  }
  displayMonth(dates) {
    let x = document?.querySelectorAll('.ngb-dp-day');
    x?.forEach((y, i) => {
      if (y.getAttribute('aria-label')) {
        const dateSearch = this.dateToString(y.getAttribute('aria-label'));
        if (Number(dateSearch.split('/')[1]) === this.currentMonth) {
          if (moment(new Date()).isAfter(moment(dateSearch, 'DD/MM/YYYY'))) {
            document.getElementById(y.children[0].children[1].id).innerHTML = '';
            y.classList.add('customCss');
            document.getElementById(y.children[0].children[0].id).className = 'disabled';
            document.getElementById(y.children[0].id).addEventListener('click', function (e) {
              e.stopPropagation();
            });
          } else if (dates?.some((el) => el === dateSearch)) {
            document.getElementById(y.children[0].children[0].id).className = 'openedDayCss';
          } else {
            document.getElementById(y.children[0].children[0].id).className = 'closedDayCss';
          }
          if (
            moment(this.dateToString(x[15].getAttribute('aria-label')), 'DD/MM/YYYY').isBefore(moment(dateSearch, 'DD/MM/YYYY'), 'month') ||
            moment(this.dateToString(x[15].getAttribute('aria-label')), 'DD/MM/YYYY').isAfter(moment(dateSearch, 'DD/MM/YYYY'), 'month')
          ) {
            document.getElementById(y.children[0].children[0].id).classList.add('blur');
          }
          if (this.setWorkshopDayHourForm?.value.workshopClosedDates?.some((el) => el === dateSearch)) {
            document.getElementById(y.children[0].children[0].id).className = 'closedDayCss';
          }
        }
      }
    });
  }

  onClose(event) {
    if (this.showRecurringDay) {
      this.displayMonth(this.setWorkshopDayHourForm?.value.workshopOpenDates);
    }
  }
  updateDate(day, month, year) {
    this.isFormValid = true;

    const dayStr = day.toString();
    const monthStr = month.toString();
    const yearStr = year.toString();
    const date = dayStr.padStart(2, '0') + '/' + monthStr.padStart(2, '0') + '/' + yearStr;
    if (moment(new Date()).isAfter(moment(date, 'DD/MM/YYYY'))) {
    } else if (this.setWorkshopDayHourForm?.value.workshopOpenDates?.some((el) => el === date)) {
      this.setWorkshopDayHourForm.patchValue({
        workshopOpenDates: this.setWorkshopDayHourForm?.value?.workshopOpenDates?.filter((item) => item !== date),
      });
      this.setWorkshopDayHourForm.patchValue({ workshopClosedDates: [...this.setWorkshopDayHourForm?.value?.workshopClosedDates, date] });

      this.displayMonth(this.setWorkshopDayHourForm?.value?.workshopOpenDates);
    } else {
      this.setWorkshopDayHourForm.patchValue({ workshopOpenDates: [...this.setWorkshopDayHourForm?.value?.workshopOpenDates, date] });
      this.setWorkshopDayHourForm.patchValue({
        workshopClosedDates: this.setWorkshopDayHourForm?.value?.workshopClosedDates?.filter((item) => item !== date),
      });

      this.displayMonth(this.setWorkshopDayHourForm?.value?.workshopOpenDates);
    }
  }
  navigateCalendar(event) {
    this.currentMonth = event.next.month;
    let x = document.querySelectorAll('.ngb-dp-day');
    setTimeout(() => {
      if (x[0]?.getAttribute('aria-label') && x[x.length - 1]?.getAttribute('aria-label')) {
        this.fetchMonthlyViewForOrder(
          this.dateToString(x[0]?.getAttribute('aria-label')),
          this.dateToString(x[x.length - 1]?.getAttribute('aria-label'))
        );
      }
    }, 100);
  }

  showAdhocSelection() {
    if (
      this.setWorkshopDayHourForm?.value?.recurringStartDate &&
      (this.setWorkshopDayHourForm?.value?.recurringOpenDays.length > 0 || this.setWorkshopDayHourForm?.value?.recurringCloseDays.length > 0)
    ) {
      this.confirmationService.confirm({
        message: 'You have unsave recurring change. Do you want to Save ? ',
        key: 'sendMenuChangeConfirm',
        accept: () => {
          this.submitForm();
          this.showRecurringDay = false;
        },
        reject: () => {
          this.setWorkshopDayHourForm.patchValue({
            recurringOpenDays: [[]],
            recurringCloseDays: [[]],
            recurringStartDate: '',
            recurringEndDate: '',
            timeframe: '',
          });
          this.streamOpened(event);
          this.showRecurringDay = false;
        },
      });
    } else {
      this.streamOpened(event);
      this.showRecurringDay = false;
    }
  }

  showRecurringDaySelection() {
    this.isFromRecurring = true;
    let dataToUpdate = this.getDataToUpdate();
    if (
      (dataToUpdate?.workshopOpenDates.length > 0 || dataToUpdate?.workshopClosedDates?.length > 0) &&
      !arraysContainSame(this.originalWorkshopDate, dataToUpdate?.workshopOpenDates)
    ) {
      this.confirmationService.confirm({
        message: 'You have unsave Adhoc change. Do you want to Save? ',
        key: 'sendMenuChangeConfirm',
        accept: () => {
          this.submitForm();
          this.showRecurringDay = true;
        },
        reject: () => {
          this.setWorkshopDayHourForm.patchValue({
            workshopOpenDates: [],
          });
          this.originalWorkshopDate = [];
          this.showRecurringDay = true;
        },
      });
    } else {
      this.showRecurringDay = true;
    }
  }

  getColorDayStatus(day: string) {
    if (this.setWorkshopDayHourForm?.value?.recurringOpenDays.some((el) => el === day)) {
      return 'green';
    } else if (this.setWorkshopDayHourForm?.value?.recurringCloseDays.some((el) => el === day)) {
      return 'red';
    } else {
      return 'grey';
    }
  }

  changeDayStatus(day: string) {
    if (
      this.setWorkshopDayHourForm?.value?.recurringOpenDays?.some((el) => el === day) ||
      this.setWorkshopDayHourForm?.value?.recurringCloseDays?.some((el) => el === day)
    ) {
      if (this.setWorkshopDayHourForm?.value?.recurringOpenDays?.some((el) => el === day)) {
        this.setWorkshopDayHourForm.patchValue({
          recurringOpenDays: this.setWorkshopDayHourForm?.value?.recurringOpenDays?.filter((item) => item !== day),
        });
        this.setWorkshopDayHourForm.patchValue({
          recurringCloseDays: [...this.setWorkshopDayHourForm?.value?.recurringCloseDays, day],
        });
      } else {
        this.setWorkshopDayHourForm.patchValue({
          recurringCloseDays: this.setWorkshopDayHourForm?.value?.recurringCloseDays?.filter((item) => item !== day),
        });
        this.setWorkshopDayHourForm.patchValue({
          recurringOpenDays: [...this.setWorkshopDayHourForm?.value?.recurringOpenDays, day],
        });
      }
    }
  }

  submitForm(): void {
    this.loading = true;
    if (this.setWorkshopDayHourForm) {
      let dataToUpdate = this.getDataToUpdate();
      // if change in ADho change
      if (
        (dataToUpdate?.workshopOpenDates.length > 0 || dataToUpdate?.workshopClosedDates?.length > 0) &&
        !arraysContainSame(this.originalWorkshopDate, dataToUpdate?.workshopOpenDates) &&
        this.showRecurringDay === false
      ) {
        dataToUpdate.recurringStartDate = '';
        dataToUpdate.recurringOpenDays = [];
        dataToUpdate.recurringClosedDays = [];
        this.eventService
          .changeWorkshopOpenDays(dataToUpdate)
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe((data) => {
            this.loading = false;

            if (data?.ErrorFlag === '0') {
              this.toastr.success(data?.ErrorMessage);
              this.activeModal.close(true);
            } else {
              this.toastr.success(data?.ErrorMessage);
            }
          });
      }
      // if change in Day
      if (
        this.setWorkshopDayHourForm?.value?.recurringStartDate &&
        (this.setWorkshopDayHourForm?.value?.recurringOpenDays.length > 0 || this.setWorkshopDayHourForm?.value?.recurringCloseDays.length > 0) &&
        this.showRecurringDay === true
      ) {
        dataToUpdate.workshopClosedDates = [];
        dataToUpdate.workshopOpenDates = [];
        dataToUpdate.recurringStartDate = this.setWorkshopDayHourForm?.value?.recurringStartDate ?? '';
        dataToUpdate.recurringOpenDays = this.setWorkshopDayHourForm?.value?.recurringOpenDays ?? [];
        dataToUpdate.recurringClosedDays = this.setWorkshopDayHourForm?.value?.recurringCloseDays ?? [];
        this.eventService
          .changeWorkshopOpenDays(dataToUpdate)
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe((data) => {
            this.loading = false;
            if (data?.ErrorFlag === '0') {
              this.toastr.success(data?.ErrorMessage);
              this.activeModal.close(true);
            } else {
              this.toastr.error(data?.ErrorMessage);
            }
          });
      }
      if (
        arraysContainSame(this.originalWorkshopDate, dataToUpdate?.workshopOpenDates) &&
        !dataToUpdate?.recurringStartDate &&
        !(dataToUpdate?.recurringOpenDays.length > 0)
      ) {
        this.toastr.error('No change detected');
        this.activeModal.close(false);
      }
    } else {
      this.activeModal.close();
    }
    this.loading = false;
  }
  getDataToUpdate() {
    const dataToUpdate = {
      branch: this.defaultBranch,
      recurringStartDate: this.setWorkshopDayHourForm?.value?.recurringStartDate ?? '',
      recurringEndDate: this.setWorkshopDayHourForm?.value?.recurringEndDate ?? '',
      recurringOpenDays: this.setWorkshopDayHourForm?.value?.recurringOpenDays ?? [],
      recurringClosedDays: this.setWorkshopDayHourForm?.value?.recurringCloseDays ?? [],
      workshopOpenDates: this.setWorkshopDayHourForm?.value?.workshopOpenDates,
      workshopClosedDates: this.setWorkshopDayHourForm?.value?.workshopClosedDates,
    };
    return dataToUpdate;
  }

  onCheckChange(day) {
    if (this.setWorkshopDayHourForm?.value?.recurringOpenDays?.some((el) => el === day)) {
      this.setWorkshopDayHourForm.patchValue({
        recurringOpenDays: this.setWorkshopDayHourForm?.value?.recurringOpenDays?.filter((item) => item !== day),
      });
    } else if (this.setWorkshopDayHourForm?.value?.recurringCloseDays?.some((el) => el === day)) {
      this.setWorkshopDayHourForm.patchValue({
        recurringCloseDays: this.setWorkshopDayHourForm?.value?.recurringCloseDays?.filter((item) => item !== day),
      });
    } else {
      this.setWorkshopDayHourForm.patchValue({
        recurringOpenDays: [...this.setWorkshopDayHourForm?.value?.recurringOpenDays, day],
      });
    }
    if (
      this.setWorkshopDayHourForm?.value?.recurringStartDate &&
      (this.setWorkshopDayHourForm?.value?.recurringOpenDays.length > 0 || this.setWorkshopDayHourForm?.value?.recurringCloseDays.length > 0)
    ) {
      this.isFormValid = true;
    } else {
      this.isFormValid = false;
    }
  }
  isDisabled = (date: NgbDateStruct, current: { month: number; year: number }) => {
    return current.month !== date.month;
  };
}

